import React, {useEffect} from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import {booleanParaEnvio} from "../components/Form/PessoaFields";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';

/**
 * O instalador é papel, e só isso: quem ele é mora no cadastro de Pessoa, que este
 * form referencia pelo suggest em vez de embutir. Pessoa que ainda não existe se
 * cadastra pela lupa do próprio suggest, que abre o grid de Pessoa com o Adicionar.
 */
export default function InstaladorForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { ativo: true }
    });
    const { handleSubmit, reset } = methods;
    const notification = useNotification();

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const salvar = (dados: any) => {
        if (!dados.pessoa?.id) {
            notification.error('Instalador precisa da pessoa');
            return;
        }

        props.triggerSubmit({
            ...dados,
            ativo: booleanParaEnvio(dados.ativo),
        });
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                <WindowBody>
                    <fieldset>
                        <legend>Instalador</legend>
                        <div className="row">
                            <UiInputSuggest size={12} name="pessoa" router="unpessoa" idField="id" titleField="nome" label="Pessoa"/>
                            <UiInputText size={12} name="pix" label="Chave PIX"/>
                            <UiInputCheckbox size={12} name="ativo" label="Ativo"/>
                        </div>
                    </fieldset>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
